// src/components/EcosystemSection.tsx
import SectionHeading from "./SectionHeading";
import { ECOSYSTEM_FLOW, BADGES } from "../data/content.js";

const ICON_STYLES: Record<string, { bg: string; border: string }> = {
  purple: { bg:"rgba(124,58,237,.2)", border:"rgba(124,58,237,.35)" },
  cyan:   { bg:"rgba(6,182,212,.15)",  border:"rgba(6,182,212,.3)"  },
  amber:  { bg:"rgba(245,158,11,.15)", border:"rgba(245,158,11,.3)" },
  green:  { bg:"rgba(16,185,129,.12)", border:"rgba(16,185,129,.3)" },
};

const TIER_STYLES: Record<string, { bg: string; border: string; color: string; glow: string }> = {
  bronze:   { bg:"radial-gradient(circle,#2a1400 30%,#1a0e00)", border:"#cd7f32", color:"#cd7f32", glow:"rgba(205,127,50,.3)" },
  silver:   { bg:"radial-gradient(circle,#1a1a20 30%,#111118)", border:"#6b7280", color:"#9ca3af", glow:"rgba(107,114,128,.2)" },
  gold:     { bg:"radial-gradient(circle,#1a1000 30%,#100a00)", border:"#d97706", color:"#fbbf24", glow:"rgba(217,119,6,.35)"  },
  platinum: { bg:"radial-gradient(circle,#0a1020 30%,#060812)", border:"#3b82f6", color:"#60a5fa", glow:"rgba(59,130,246,.3)"  },
  legendary:{ bg:"radial-gradient(circle,#150820 30%,#0a0412)", border:"#9333ea", color:"#c084fc", glow:"rgba(147,51,234,.4)"  },
};

export default function EcosystemSection() {
  return (
    <section id="ecosystem" style={{ padding: "64px 48px", position: "relative", zIndex: 1 }}>
      <SectionHeading eyebrow="Ecosystem" title="How It" accent="Works" desc="From player action to on-chain reward — the full MeeChain loop." center />

      {/* Flow */}
      <div style={{ background:"var(--bg2)", border:"1px solid rgba(124,58,237,.25)", borderRadius:12, padding:"16px 20px", marginBottom:24 }}>
        <div style={{ fontSize:10, fontWeight:700, color:"var(--muted)", letterSpacing:".15em", textTransform:"uppercase", marginBottom:16 }}>ECOSYSTEM FLOW</div>
        <div style={{ display:"flex", alignItems:"center", gap:8, overflowX:"auto", paddingBottom:4 }}>
          {ECOSYSTEM_FLOW.map((node, i) => {
            const s = ICON_STYLES[node.iconStyle] ?? ICON_STYLES.purple;
            return (
              <>
                <div key={node.label} style={{
                  flexShrink:0, display:"flex", flexDirection:"column", alignItems:"center", gap:6,
                  padding:"14px 16px", background:"var(--bg3)", border:"1px solid rgba(124,58,237,.2)",
                  borderRadius:10, minWidth:110, textAlign:"center", cursor:"pointer",
                  transition:"all .2s",
                }}>
                  <div style={{ width:40, height:40, borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, background:s.bg, border:`1px solid ${s.border}` }}>
                    {node.icon}
                  </div>
                  <div style={{ fontSize:11, fontWeight:700, color:"var(--text)" }}>{node.label}</div>
                  <div style={{ fontSize:10, color:"var(--muted)", lineHeight:1.4 }}>{node.desc}</div>
                </div>
                {i < ECOSYSTEM_FLOW.length - 1 && (
                  <div key={`arrow-${i}`} style={{ color:"rgba(74,72,104,.8)", fontSize:16, flexShrink:0 }}>→</div>
                )}
              </>
            );
          })}
        </div>
      </div>

      {/* Badge Vault */}
      <div style={{ background:"var(--bg2)", border:"1px solid rgba(124,58,237,.25)", borderRadius:12, padding:"16px 20px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <span style={{ fontSize:16 }}>💎</span>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:"var(--text)" }}>BADGE VAULT</div>
              <div style={{ fontSize:11, color:"var(--muted)" }}>Collect · Earn · Showcase</div>
            </div>
          </div>
          <a href="#" style={{ fontSize:12, color:"var(--purple4)", textDecoration:"none", fontWeight:600 }}>VIEW ALL BADGES →</a>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:10 }}>
          {BADGES.map(badge => {
            const ts = TIER_STYLES[badge.tier] ?? TIER_STYLES.bronze;
            return (
              <div key={badge.id} style={{
                display:"flex", flexDirection:"column", alignItems:"center", gap:6,
                padding:"14px 8px 12px", background:"var(--bg3)", border:`1px solid rgba(124,58,237,.2)`,
                borderRadius:10, cursor:"pointer", textAlign:"center",
                transition:"all .2s",
              }}>
                <div style={{
                  width:72, height:72, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center",
                  fontSize:32, background:ts.bg, border:`2px solid ${ts.border}`,
                  boxShadow:`0 0 16px ${ts.glow}`,
                }}>
                  {badge.icon}
                </div>
                <div style={{ fontSize:11, fontWeight:700, color:"var(--text)" }}>{badge.name}</div>
                <div style={{ fontSize:9, fontWeight:700, letterSpacing:".08em", textTransform:"uppercase", color:ts.color }}>{badge.rarity}</div>
                <div style={{ display:"flex", alignItems:"center", gap:6, fontSize:10, color:"var(--muted)", fontFamily:"var(--mono)" }}>
                  <span>👤 {badge.holders.toLocaleString()}</span>
                  <span style={{ color:"var(--purple4)", fontWeight:600 }}>{badge.xpBonus}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
